export const blockIconsAndroidCableNew = (
	<span className='material-symbols-outlined'>cable</span>
);
